import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Chip, Box } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, Divider, Typography, Grid } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { EVENTS } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import { useTheme } from '@mui/material/styles';
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import moment from "moment";
import AppTooltip from "src/components/common/AppTooltip";
import EyeOpenIcon from 'src/svgComponents/EyeOpenIcon'
import CloseIcon from '@mui/icons-material/Close';
import LocationIcon from '@mui/icons-material/LocationOn'
import ClockIcon from '@mui/icons-material/AccessTime'
const _ = require('lodash');

const BookedTicket = () => {
    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('createdAt');
    const axiosPrivate = useAxiosPrivate();
    const [showImage, setShowImage] = useState();
    const [filterName, setFilterName] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const [deleteId, setdeleteId] = useState("");
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const [loding, setLoding] = useState(true);
    const [modelTitle, setmodelTitle] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [data, setData] = useState([]);
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#ffffff',
        },
        '&:nth-of-type(even)': {
            background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
        },
        // hide last border
        '& td, & th': {
            border: 0,
        },
    }));

    const TABLE_HEAD = [
        { id: 'userName', label: 'Username', alignRight: false },
        { id: 'email', label: 'Email', alignRight: false },
        { id: 'price', label: 'Paid amount', alignRight: false },
        { id: 'booking_date', label: 'Booking Date', alignRight: false },
        { id: 'name', label: 'Event name', alignRight: false },
        { id: 'image', label: 'Image', alignRight: false },
        { id: 'time', label: 'Time', alignRight: false },
        { id: 'city', label: 'City', alignRight: false },
        { id: 'action', label: 'Action', alignRight: false },
    ];

    async function getbookedList(page, filterName) {
        const response = await axiosPrivate.get(EVENTS.getbookedList, { params: { page: page + 1, search: filterName, status: 2, limit: rowsPerPage } })
        return response.data[0];
    }

    const { data: bookedEventList, refetch } = useQuery(['bookedEventList', page, filterName], () => getbookedList(page, filterName), { keepPreviousData: true, })

    useEffect(() => {
        if (bookedEventList) {
            setTableData(bookedEventList.data);
            setRowsPerPage(bookedEventList?.metadata.length != 0 ? bookedEventList?.metadata[0].limit : 10);
        }
        if (bookedEventList?.metadata.length != 0 && bookedEventList?.metadata[0].hasMoreData == true) {
            getbookedList(page + 1);
        }
        setLoding(false);
    }, [bookedEventList])

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setTimeout(() => {
            refetch();
        }, 500);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleFilterByName = (event) => {
        setFilterName(event.target.value.trim());
        setPage(0);
        getbookedList(page, filterName)
        refetch();
    };

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
    function applySortFilter(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });

        return stabilizedThis.map((el) => el[0]);
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

    const handleClose = () => {
        setOpen(false);
        setShowImage('');
    };

    const deleteOrder = async () => {
        const response = await axiosPrivate.delete(EVENTS.deleteOrder + deleteId)
        if (response.status == 200) {
            enqueueSnackbar("Order delete successfully", {
                variant: "success",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        } else {
            enqueueSnackbar("something went wrong", {
                variant: "error",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        }
        refetch();
        handleClose();
    };
    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const handleView = (row) => {
        setmodelTitle('Booking Detail');
        setData(row);
        setOpenModal(true);
    };

    return (
        <Box>
            {loding ? <LoadingScreen /> : <>
                <div className="dashboard_header mb-4">
                    <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Booked Event List</h4>
                    <Paper component="form" className='dashboard_searchbox col-lg-4'>
                        <IconButton>
                            <SearchIcon />
                        </IconButton>
                        <InputBase
                            fullWidth
                            sx={{ flex: 1 }}
                            placeholder="search ..."
                            onChange={(e) => handleFilterByName(e)}
                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                        />
                    </Paper>
                </div>
                <Card>
                    <TableContainer>
                        <Table>
                            <UserListHead
                                headLabel={TABLE_HEAD}
                                rowCount={bookedEventList?.data?.length}
                                onRequestSort={handleRequestSort}
                            />
                            {filteredUsers?.length > 0 ?
                                <TableBody>
                                    {filteredUsers.map((row) => {
                                        return (
                                            <StyledTableRow key={row._id}>
                                                <TableCell align="left"> {row?.userName ?? '-'} </TableCell>
                                                <TableCell align="left"> {row?.email ?? '-'} </TableCell>
                                                <TableCell align="left"> £{row?.amount?.toFixed(2) ?? '-'} </TableCell>
                                                <TableCell align="left"> {moment(row.createdAt).format("DD MMM YYYY h:mm A")}</TableCell>
                                                <TableCell align="left"> {row?.name} </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <img src={process.env.REACT_APP_PROFILE_URL + 'eventImage/' + row.image} height="50px" alt="profile" />
                                                </TableCell>
                                                <TableCell align="left"> {moment(row.time).format("DD MMM YYYY h:mm A")} </TableCell>
                                                <TableCell align="left"> {row?.city ?? '-'} </TableCell>
                                                <TableCell>
                                                    <AppTooltip title="View" placement="bottom"><IconButton sx={{ "&:hover": { bgcolor: "transparent" } }}
                                                        onClick={() => handleView(row)}
                                                        variant="text"><EyeOpenIcon /></IconButton></AppTooltip>
                                                </TableCell>
                                            </StyledTableRow>
                                        )
                                    })}
                                </TableBody>
                                :
                                <TableBody>
                                    <TableRow>
                                        <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                            <span className="app_text_16_semibold">No Data Found</span>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>}
                        </Table>
                    </TableContainer>
                    <TablePagination
                        component="div"
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        count={bookedEventList?.metadata.length != 0 ? bookedEventList?.metadata[0].total : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </>
            }
            <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" className='m-auto'>
                    {"are you sure you want to delete?"}
                </DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions className='m-auto'>
                    <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                        cancel
                    </Button>
                    <Button className="theme_button" variant="contained" onClick={() => deleteOrder()} autoFocus>
                        delete
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h4>{modelTitle}</h4>
                        <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                            <CloseIcon style={{ color: '#fff' }} />
                        </Button>
                    </Box>
                </DialogTitle>
                <DialogContent className="custom_form_mui pt-2">
                    <Grid container spacing={2} sx={{ py: 2 }}>
                        <Grid item xs={12}>
                            <Typography className="app_text_16_semibold">
                                {data?.name}
                            </Typography>
                            <Stack
                                display={"flex"}
                                alignItems="flex-start"
                                spacing={3}
                                direction={"row"}
                            >
                                <Box
                                    sx={{
                                        height: "100px",
                                        width: "100px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        borderRadius: "12px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <img
                                        src={
                                            data?.image
                                                ? process.env.REACT_APP_PROFILE_URL +
                                                "eventImage/" +
                                                data?.image
                                                : ""
                                        }
                                        alt=""
                                        style={{
                                            height: "100%",
                                            width: "100%",
                                            objectFit: "cover",
                                            objectPosition: "center",
                                        }}
                                    />
                                </Box>
                                <Box>
                                    <p><LocationIcon style={{ "color": "gray", fontSize: "13px" }} /> {data?.city}</p>
                                    <p><ClockIcon style={{ "color": "gray", fontSize: "13px" }} /> {moment(data?.time).format("hh:mm A")}</p>
                                </Box>
                            </Stack>

                        </Grid>
                        <Grid item xs={12}>
                            <Typography className="app_text_16_semibold">
                                Booking Details
                            </Typography>
                            <Box
                                sx={{
                                    border: "1px solid gainsboro",
                                    padding: "16px",
                                    marginTop: 4,
                                }}
                            >
                                <div className="row">
                                    <div className="col-3">
                                        <Typography className="app_text_14_semibold">
                                            Event Booking Id
                                        </Typography>
                                        <Typography className="app_text_12_fw500 app_text_gray">
                                            {data.booking_id}
                                        </Typography>
                                    </div>
                                    <div className="col-3">
                                        <Typography className="app_text_14_semibold">
                                            Email
                                        </Typography>
                                        <Typography className="app_text_12_fw500 app_text_gray">
                                            {data.email}
                                        </Typography>
                                    </div>
                                    <div className="col-2">
                                        <Typography className="app_text_14_semibold">
                                            User Name
                                        </Typography>
                                        <Typography className="app_text_12_fw500 app_text_gray">
                                            {data.userName}
                                        </Typography>
                                    </div>
                                    <div className="col-2">
                                        <Typography className="app_text_14_semibold">
                                            No.of People
                                        </Typography>
                                        <Typography className="app_text_12_fw500 app_text_gray">
                                            {data.no_of_people}
                                        </Typography>
                                    </div>
                                    <div className="col-2">
                                        <Typography className="app_text_14_semibold">
                                            Date
                                        </Typography>
                                        <Typography className="app_text_12_fw500 app_text_gray">
                                            {moment(data.createdAt).format("DD MMM YYYY")}
                                        </Typography>
                                    </div>
                                </div>
                            </Box>
                            <Grid item xs={12}>
                                <Typography className="app_text_16_semibold">
                                    Tickets
                                </Typography>
                                <Box
                                    sx={{
                                        border: "1px solid gainsboro",
                                        padding: "16px",
                                        marginTop: 4,
                                    }}
                                >
                                    <div className="row">
                                        {
                                            data?.tickets?.map((val, key) => {
                                                return (
                                                    <>
                                                        <div className="col-2">
                                                            {
                                                                val?.image &&
                                                                <img
                                                                    src={process.env.REACT_APP_PROFILE_URL +
                                                                        "tickets/" +
                                                                        val?.image
                                                                    }
                                                                    alt=""
                                                                    style={{
                                                                        height: "50%",
                                                                        width: "60%",
                                                                        objectFit: "cover",
                                                                        objectPosition: "center",
                                                                    }}
                                                                /> || ""
                                                            }

                                                        </div>
                                                        <div className="col-2">
                                                            <Typography className="app_text_14_semibold">
                                                                Ticket Number
                                                            </Typography>
                                                            <Typography className="app_text_12_fw500 app_text_gray">
                                                                {val?.ticket_number}
                                                            </Typography>
                                                        </div>
                                                    </>
                                                )
                                            })
                                        }
                                    </div>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </Box >
    )
}

export default BookedTicket